import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";

export const IconStopShareScreen: React.NamedExoticComponent<CentralIconBaseProps> = React.memo(React.forwardRef<SVGSVGElement, CentralIconBaseProps>((props, ref) => {
  return <CentralIconBase {...props} ref={ref} ariaLabel={"stop-share-screen, stop-sharing"} maskId="square-filled-radius-0-stroke-1-IconStopShareScreen"><path fillRule="evenodd" clipRule="evenodd" d="M22 20H2V4H22V20ZM12 11.293L8.85352 8.14648L8.14648 8.85352L11.293 12L8.14648 15.1465L8.85352 15.8535L12 12.707L15.1465 15.8535L15.8535 15.1465L12.707 12L15.8535 8.85352L15.1465 8.14648L12 11.293Z" fill="currentColor"/></CentralIconBase>;
}));

export default IconStopShareScreen;
